// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__39jrP","description":"MealItem_description__2UhVu","price":"MealItem_price__9bXLL"};